import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatGender', value => {
  if (value === 1) {
    return 'Nam'
  } else if (value === 2) {
    return 'Nữ'
  } else {
    return 'Khác'
  }
})

Vue.filter('formatIntToDate', value => {
  if (value) {
    return moment.unix(value).format('DD-MM-YYYY')
  }
})
Vue.filter('formatIntToDateV2', value => {
  if (value) {
    return moment.unix(value).format('DD/MM/YYYY')
  }
})
Vue.filter('formatDateToInt', value => {
  if (value) {
    return parseInt(moment(value, 'DD-MM-YYYY').format('X'))
  }
})
